var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.487,
    height: 18.438,
    viewBox: "0 0 14.487 18.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-filled",
    transform: "translate(-7.5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27239",
    "data-name": "Path 27239",
    d: "M14.743,3A7.252,7.252,0,0,0,7.5,10.243,7.17,7.17,0,0,0,8.959,14.59s.2.26.23.3l5.554,6.551L20.3,14.884c.029-.035.227-.294.227-.294v0a7.168,7.168,0,0,0,1.459-4.344A7.252,7.252,0,0,0,14.743,3Zm0,9.877a2.634,2.634,0,1,1,2.634-2.634,2.634,2.634,0,0,1-2.634,2.634Z",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "IconifyId-17e9079768a-d1151c-107",
    cx: 2.918,
    cy: 2.918,
    r: 2.918,
    transform: "translate(11.826 7.411)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilled);
export default __webpack_public_path__ + "static/media/location-filled.8ab72992bc8dcbe18f38ad7e4673f26b.svg";
export { ForwardRef as ReactComponent };